import { createContext } from 'react';
import { type ArtTextStruct, type ListStyleStruct } from '@/types';

export interface ITextPanelContext {
    layerId: string;
    theme: string;
    isIntl: boolean;
    recordId?: number;
    showArtTextEntry: boolean;
    listStyles: ListStyleStruct[];
    artTexts?: ArtTextStruct[];
    isVIP?: boolean;
    onOpenVIPModal?: () => void;
    onOpenArtText?: () => void;
    onOpenSubPanel: (subPanel: string, type?: string) => void;
}

export const TextPanelContext = createContext<ITextPanelContext | null>(null);
